// import logo from './logo.svg';
// import '../src/assets/styles/navbar.css';
// import Navbar from './component/Navbar';
// import Home from './component/Home/Home';
// import '../src/assets/styles/home.css';
// import AboutSection from './component/About/about';
// import '../src/assets/styles/about.css';
// import {
//   BrowserRouter as Router,
//   Route,
//   Routes,
// } from "react-router-dom";
// // import ScrollToTop from './component/ScrollTop';


// const App = () => {
//   return (
//     <Router>
//     <div className="App">
//       <Navbar />
//       {/* <ScrollToTop /> */}
//       <Routes>
//          <Route path="/" element={<Home/>} />
//          <Route path="/AboutSection" element={<AboutSection/>} />
         
         
//       </Routes>
//     </div>
//     </Router>
//   );
// }

// export default App;

import '../src/assets/styles/navbar.css';
import Navbar from './component/Navbar';
import Home from './component/Home/Home';
import '../src/assets/styles/home.css';
import AboutSection from './component/About/about'; 
import '../src/assets/styles/about.css';
import Footer from './component/Footer';
import '../src/assets/styles/footer.css';
import ProjectCards from './component/Project/Project';
import '../src/assets/styles/project.css';
import Resume from './component/Resume/resume';
import '../src/assets/styles/resume.css'


import {
  BrowserRouter as Router,
  Route,
  Routes,
} from "react-router-dom";


const App = () => {
  return (
    <Router>
      <div className="App">
        <Navbar />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutSection />} />
          <Route path="/Project" element={<ProjectCards />} />
          <Route path="/Resume" element={<Resume/>} />
        </Routes>

        <Footer />
      </div>
    </Router>
  );
};

export default App;

